export default {"src":"/_next/static/media/cudis.2a578385.svg","height":180,"width":201,"blurWidth":0,"blurHeight":0};